import React, { useEffect, useState } from "react";
import { getSdvVehicleFeatureList } from "../../services/SdvFeature";
import OTAPagination from "../OTAPagination";
import { getSdvFeatureVehiclesDataColumns } from './SdvFeatureVehiclesDataColumns'

const SdvVehicleFeatureDataGrid = (props) => {
  const { sdvFeatureId, setSelectedRows, selectedRows } = props;
  const columns = getSdvFeatureVehiclesDataColumns();

  const getSdvVehicleFeatureListForSdvId = (params) => {
    return getSdvVehicleFeatureList(params, sdvFeatureId);
  };

  return (
    <OTAPagination
      columns={columns}
      endpointFn={getSdvVehicleFeatureListForSdvId}
      queryName={"getSdvVehicleFeatureListForSdvId"}
      filterMode="server"
      sortByDefault={"createdAt"}
      getRowId={(row) => row.vehicleKey}
      checkboxSelection
      selectionModel={selectedRows}
      onSelectionModelChange={(selectionModel) => {
        setSelectedRows(selectionModel);
      }}
    />
  );
};

export default SdvVehicleFeatureDataGrid;
